export default interface IEPGUpdater {
    start(): Promise<void>;
}
